export default "__VITE_ASSET__CbzR2taS__"